import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function FleetSix(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={300}>
        <div className="fleetSix">
          <div className={`card1 card ${isVisible ? 'visible' : ''}`}>
            <iframe width="560" height="500" src="https://www.youtube.com/embed/grMoTkQ7pR8?si=qGontIO0xWAt-EgN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>            
            <div className="cardText">
              <h3>{t("fleet_six_card1_title")}</h3>
              <p>{t("fleet_six_card1_text")}</p>
            </div>
          </div>
          <div className={`card2 card ${isVisible ? 'visible' : ''}`}>
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/mKU66ntC5mc?si=y2z7ooVzJmKFn_SP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="cardText">
              <h3>{t("fleet_six_card2_title")}</h3>
              <p>{t("fleet_six_card2_text")}</p>
            </div>
          </div>
          <div className={`card3 card ${isVisible ? 'visible' : ''}`}>
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/avfPeE-rLv8?si=AZASih1tVrQTk0mo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="cardText">
              <h3>{t("fleet_six_card3_title")}</h3>
              <p>{t("fleet_six_card3_text")}</p>
            </div>
          </div>
          <div className={`card4 card ${isVisible ? 'visible' : ''}`}>
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/Wo0IZuEBeCM?si=fm-2ADgQ0D-pKhEh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="cardText">
              <h3>{t("fleet_six_card4_title")}</h3>
              <p>{t("fleet_six_card4_text")}</p>
            </div>
          </div>
          <div className={`card5 card ${isVisible ? 'visible' : ''}`}>
            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/t0vVd5hefSw?si=Ull4Yeg0s298b3E1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="cardText">
              <h3>{t("fleet_six_card5_title")}</h3>
              <p>{t("fleet_six_card5_text")}</p>
            </div>
          </div>
        </div>
        </VisibilitySensor>
    )
}
export default FleetSix;